/* Explosions-Effekt (snippets/explosion.liquid). Produktkarte: nur Hover per CSS. Produktseite (sections/main-product.liquid, .xplx):
   Maus über Bühne oder Legende öffnet, Klick/Antippen der Bühne oder der Knopf schaltet um, die Legende hebt ihre Schicht hervor.
   Nie beim Scrollen (Inhaber 16.10.). */
(() => {
  const mouse = matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('[data-xpl-box]').forEach((box) => {
    const xpl = box.querySelector('[data-xpl]');
    if (!xpl) return;
    const stage = box.querySelector('.xplx__stage') || xpl;
    const btn = box.querySelector('[data-xpl-btn]');
    let pinned = false;
    const isOpen = () => box.classList.contains('is-open');
    const set = (open) => {
      box.classList.toggle('is-open', open);
      xpl.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-pressed', open);
    };
    const hot = (i) => {
      box.querySelectorAll('[data-i]').forEach((el) => el.classList.toggle('is-hot', el.dataset.i === i));
      box.classList.toggle('has-hot', i != null);
    };
    const rest = () => { if (!pinned && !stage.matches(':hover')) set(false); };
    stage.addEventListener('mouseenter', () => { if (mouse.matches && !pinned) set(true); });
    stage.addEventListener('mouseleave', () => { if (mouse.matches) { hot(null); rest(); } });
    // Klick (Hinweis „Klick mich“): Maus hält das Gericht offen bzw. setzt es wieder zusammen, Touch schaltet um
    stage.addEventListener('click', () => { pinned = mouse.matches ? !pinned : !isOpen(); set(pinned); hot(null); });
    if (btn) btn.addEventListener('click', () => { pinned = !isOpen(); set(pinned); hot(null); });
    box.querySelectorAll('.xplx__item').forEach((item) => {
      item.addEventListener('mouseenter', () => { if (!mouse.matches) return; set(true); hot(item.dataset.i); });
      item.addEventListener('mouseleave', () => { if (!mouse.matches) return; hot(null); rest(); });
      item.addEventListener('click', () => {
        if (mouse.matches) return;
        pinned = true; set(true);
        hot(item.classList.contains('is-hot') ? null : item.dataset.i);
      });
    });
  });
})();
